import { render } from "./ScreenshareTile.vue?vue&type=template&id=b63e94bc&scoped=true"
import script from "./ScreenshareTile.vue?vue&type=script&lang=js"
export * from "./ScreenshareTile.vue?vue&type=script&lang=js"

import "./ScreenshareTile.vue?vue&type=style&index=0&id=b63e94bc&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b63e94bc"]])

export default __exports__